import React, { useContext } from "react";
import { Button } from "@material-ui/core";
import { NavHashLink as NavLink } from "react-router-hash-link";
import { makeStyles } from "@material-ui/core/styles";

import "./Landing.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import { headerData } from "../../data/headerData";
import { socialsData } from "../../data/socialsData";
import proPic from "./img/profile_prof.png";
// import proPic from "./img/professional_pic.jpg";

import {
  FaInstagram,
  FaLinkedin,
  FaGithub,
  FaTwitter,
} from "react-icons/fa";

import { SiLeetcode } from "react-icons/si";
import TypewriterText from "../Common/TypewriterText/TypewriterText";
import BlurText from "../Common/BlurText";
import { Fade } from "react-reveal";

function Landing() {
  const { theme, drawerOpen } = useContext(ThemeContext);

  const useStyles = makeStyles((t) => ({
    resumeBtn: {
      color: theme.primary,
      borderRadius: "30px",
      textTransform: "inherit",
      textDecoration: "none",
      width: "150px",
      fontSize: "1rem",
      fontWeight: "500",
      height: "50px",
      fontFamily: "var(--primaryFont)",
      border: `3px solid ${theme.primary}`,
      transition: "100ms ease-out",
      position: "relative",
      overflow: "hidden",
      "&:hover": {
        backgroundColor: theme.tertiary,
        color: theme.secondary,
        border: `3px solid ${theme.tertiary}`,
      },
      "&::before": {
        // Added shine effect
        content: '""',
        position: "absolute",
        top: 0,
        left: "-100%",
        width: "15%",
        height: "100%",
        background: `linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.3), transparent)`,
        animation: "$shine 2.5s infinite linear",
      },
      [t.breakpoints.down("sm")]: {
        width: "180px",
      },
    },
    "@keyframes shine": {
      "100%": {
        left: "200%",
      },
    },
    contactBtn: {
      backgroundColor: theme.primary,
      color: theme.secondary,
      borderRadius: "30px",
      textTransform: "inherit",
      textDecoration: "none",
      width: "150px",
      height: "50px",
      fontSize: "1rem",
      fontWeight: "500",
      fontFamily: "var(--primaryFont)",
      border: `3px solid ${theme.primary}`,
      transition: "100ms ease-out",
      "&:hover": {
        backgroundColor: theme.secondary,
        color: theme.tertiary,
        border: `3px solid ${theme.tertiary}`,
      },
      [t.breakpoints.down("sm")]: {
        display: "none",
      },
    },
  }));

  const classes = useStyles();

  return (
    <div className="landing">
      <div className="landing--container">
        <div
          className="landing--container-left"
          style={{ backgroundColor: theme.primary }}
        >
          <div className="lcl--content">
            {socialsData.linkedIn && (
              <a href={socialsData.linkedIn} target="_blank" rel="noreferrer">
                <FaLinkedin
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="LinkedIn"
                />
              </a>
            )}
            {socialsData.github && (
              <a href={socialsData.github} target="_blank" rel="noreferrer">
                <FaGithub
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="GitHub"
                />
              </a>
            )}
            {socialsData.instagram && (
              <a href={socialsData.instagram} target="_blank" rel="noreferrer">
                <FaInstagram
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="Twitter"
                />
              </a>
            )}
            {socialsData.twitter && (
              <a href={socialsData.twitter} target="_blank" rel="noreferrer">
                <FaTwitter
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="Twitter"
                />
              </a>
            )}
            {socialsData.leetcode && (
              <a href={socialsData.leetcode} target="_blank" rel="noreferrer">
                <SiLeetcode
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="Twitter"
                />
              </a>
            )}
            {/* {socialsData.youtube && (
              <a href={socialsData.youtube} target="_blank" rel="noreferrer">
                <FaYoutube
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="YouTube"
                />
              </a>
            )} */}
            {/* {socialsData.blogger && (
              <a href={socialsData.blogger} target="_blank" rel="noreferrer">
                <FaBlogger
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="Blogger"
                />
              </a>
            )} */}
          </div>
        </div>
        <img
          src={proPic}
          alt=""
          className="landing--img"
          style={{
            opacity: `${drawerOpen ? "0" : "1"}`,
            borderColor: theme.secondary,
          }}
        />
        <div
          className="landing--container-right"
          style={{ backgroundColor: theme.secondary }}
        >
          <div className="lcr--content" style={{ color: theme.tertiary }}>
            <BlurText
              text={headerData.smallIntro}
              delay={400}
              animateBy="words"
              direction="top"
              // onAnimationComplete={handleAnimationComplete}
              className="blurry-name"
            />
            {/* <h1>{headerData.smallIntro}</h1> */}
            <TypewriterText texts={headerData.title} />
            <Fade right>
              <p>{headerData.desciption}</p>

              <div className="lcr-buttonContainer">
                {headerData.resumePdf && (
                  <a
                  href="#resume"
                  // download="Manasvi_Sharma_Resume"
                  // target="_blank"
                  // rel="noreferrer"
                  >
                    <Button
                      onClick={(e) => {
                        e.preventDefault();

                        window.open(
                          "https://drive.google.com/file/d/1W5XO6m-uPA11c-PuPYVJTAKOzh1n-3bK/view?usp=sharing",
                          "_blank"
                        );
                      }}
                      className={classes.resumeBtn}
                    >
                      Download CV
                    </Button>
                  </a>
                )}
                <NavLink
                  to="/#contacts"
                  smooth={true}
                  spy="true"
                  duration={2000}
                >
                  <Button className={classes.contactBtn}>Contact</Button>
                </NavLink>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
